import React from 'react';
import './style.scss';
import cn from 'classnames';

interface ButtonProps {
  title?: string;
  type?: 'primary' | 'secondary';
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  title = '',
  type = 'primary',
  onClick = null,
  className = '',
  disabled = false,
  isLoading = false,
}) => {
  const buttonClass = cn('button', type, className, { disabled: disabled || isLoading });

  return (
    <button
      className={buttonClass}
      onClick={!disabled && !isLoading ? onClick : undefined}
      disabled={disabled || isLoading}
    >
      {isLoading ? <span className='button__spinner' /> : title}
    </button>
  );
};

export default Button;
